export default {
  API_URL:
    process.env.API_URL ||
    'https://p1ep48wiwe.execute-api.us-west-2.amazonaws.com/craft',
}
